module.exports = __webpack_public_path__ + "static/media/core.0b5dc31a.svg";